import React, { type FunctionComponent } from 'react'
import { Dialog } from '../Dialog'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  title: string
  description?: string
  confirmButtonText: string
  cancelButtonText: string
  onCancel: () => void
  onConfirm: () => void
}

export const ConfirmDialog: FunctionComponent<Props> = ({
  title,
  description,
  cancelButtonText,
  confirmButtonText,
  onCancel,
  onConfirm
}) => {
  return (
    <Dialog ariaLabel={title}>
      <div className="rounded-2xl bg-white shadow-md dark:bg-gray-900 p-6 min-w-screen-sm max-w-screen-sm">
        <h1 className="font-bold text-xl mb-6">{title}</h1>
        {description && <p>{description}</p>}

        <div className="mt-6 flex space-x-4 justify-end">
          <Button onClick={onCancel}>{cancelButtonText}</Button>

          <Button variant="primary" onClick={onConfirm}>
            {confirmButtonText}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
